<template>
  <div>
    <AppButtonReadonly
      v-if="isReadOnly"
      @click="simulationEdit"
      style="display: flex;"
    />
    <AppIconEdit
      v-if="!isReadOnly"
      @click="simulationEdit"
      style="display: flex;"
    />
  </div>
</template>

<script>
import AppIconEdit from '@/components/App/AppIconEdit'
import AppButtonReadonly from '@/components/App/AppIconReadonly'

export default {
  name: 'ButtonEdit',
  components: { AppIconEdit, AppButtonReadonly },
  props: {
    simulationPlanId: {
      type: Number,
      default: 0,
    },
    isReadOnly: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    simulationEdit() {
      this.$router.push(`simulations/${this.simulationPlanId}/edit`)
    },
  },
}
</script>

<style scoped></style>
